var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.themeClass},[(!_vm.spinner)?_c('div',{staticClass:"loading-text"},[_vm._v("\n        Loading...\n    ")]):_vm._e(),_vm._v(" "),(_vm.spinner)?_c('div',{staticClass:"loading-text spinner"},[_c('div',{staticClass:"typing_loader"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }